<script>

import { Select } from 'element-ui'
export default {
  name: 'CargoElSelect',
  extends: Select,
  mounted() {
    this.$refs.reference.$el.addEventListener('input', this.debouncedOnInputChange)
  },
  beforeDestroy() {
    this.$refs.reference.$el.removeEventListener('input', this.debouncedOnInputChange)
  },
  methods: {
    handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown) {
          this.visible = true
          if (this.filterable) {
            this.menuVisibleOnFocus = true
          }
        }
        this.$emit('focus', event)
      } else {
        this.softFocus = false
      }
    },
    setSelected() {
      if (!this.multiple) {
        const option = this.getOption(this.value)
        if (option.created) {
          this.createdLabel = option.currentLabel
          this.createdSelected = true
        } else {
          this.createdSelected = false
        }
        this.selectedLabel = typeof option.currentLabel === 'boolean' ? String(option.currentLabel) : option.currentLabel
        this.selected = option
        if (this.filterable) this.query = this.selectedLabel
        return
      }
      const result = []
      if (Array.isArray(this.value)) {
        this.value.forEach(value => {
          result.push(this.getOption(value))
        })
      }
      this.selected = result
      this.$nextTick(() => {
        this.resetInputHeight()
      })
    }
  }
}
</script>
